import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { ListarTareaResponsablesComponent } from "./listar-tarea-responsables/listar-tarea-responsables.component";
import { CompletarTareaResponsableComponent } from "./completar-tarea-responsable/completar-tarea-responsable.component";
import { CompletarTareaResponsableDialog } from "./completar-tarea-responsable/completar-tarea-responsable-dialog/completar-tarea-responsable-dialog.component";
import { CrearTareaResponsableComponent } from "./crear-tarea-responsable/crear-tarea-responsable.component";
import { CrearTareaResponsableDialog } from "./crear-tarea-responsable/crear-tarea-responsable-dialog/crear-tarea-responsable-dialog.component";
import { EliminarTareaResponsableComponent } from "./eliminar-tarea-responsable/eliminar-tarea-responsable.component";
import { EliminarTareaResponsableDialog } from "./eliminar-tarea-responsable/eliminar-tarea-responsable-dialog/eliminar-tarea-responsable-dialog.component";
import { TareaResponsableComponent } from "./tarea-responsable/tarea-responsable.component";
import { PipesModule } from "../../../pipes/pipes.module";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MaterialModule } from "../../../components/material/material.module";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        PipesModule,
        ReactiveFormsModule,
        FormsModule,
        MaterialModule,
    ],
    declarations: [
        CompletarTareaResponsableComponent,
        CompletarTareaResponsableDialog,
        CrearTareaResponsableComponent,
        CrearTareaResponsableDialog,
        EliminarTareaResponsableComponent,
        EliminarTareaResponsableDialog,
        ListarTareaResponsablesComponent,
        TareaResponsableComponent,
    ],
    entryComponents: [
        CompletarTareaResponsableDialog,
        CrearTareaResponsableDialog,
        EliminarTareaResponsableDialog
    ],
    exports: [
        CompletarTareaResponsableComponent,
        ListarTareaResponsablesComponent,
        TareaResponsableComponent,
    ]
})
export class TareaResponsablesModule { }